// extracted by mini-css-extract-plugin
export default {"OpenButton":"UnfinishedRevisionTable_OpenButton__8AKDl"};